"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingActionButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = require("react");
const useDelayedState_1 = require("../../hooks/useDelayedState");
const Badge_1 = require("../Badge");
const Box_1 = require("../Box");
const Button_1 = require("../Button");
const Card_1 = require("../Card");
const FloatingActionButton = (_a) => {
    var { icon, children, toggledComponent, badge, onClick, toggledVisible, onToggle = () => { }, label, labelPosition = 'right', buttonRef, buttonProps = {} } = _a, props = __rest(_a, ["icon", "children", "toggledComponent", "badge", "onClick", "toggledVisible", "onToggle", "label", "labelPosition", "buttonRef", "buttonProps"]);
    const [visible, setVisible] = react_1.useState(false);
    const [hover, setHover] = useDelayedState_1.useDelayedState(false, 0, 50);
    react_1.useEffect(() => {
        if (toggledVisible === undefined) {
            return;
        }
        setVisible(toggledVisible);
    }, [toggledVisible]);
    const showToggledComponent = toggledComponent && visible;
    const dismiss = react_1.useCallback(() => {
        setVisible(false);
        onToggle(false);
    }, [onToggle]);
    const buttonContainerRef = react_1.useRef(null);
    react_1.useEffect(() => {
        const onClick = (e) => {
            if (buttonContainerRef.current && !buttonContainerRef.current.contains(e.target)) {
                dismiss();
            }
        };
        document.addEventListener('click', onClick);
        return () => {
            document.addEventListener('click', onClick);
        };
    }, [dismiss]);
    react_1.useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === 'Escape') {
                dismiss();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.addEventListener('keydown', onKeyDown);
        };
    }, [dismiss]);
    return (jsx_runtime_1.jsxs(Box_1.Box, Object.assign({ position: "relative", ref: buttonContainerRef }, props, { children: [showToggledComponent && (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ display: "block", position: "absolute", top: 0, left: "3.5rem" }, { children: typeof toggledComponent === 'function'
                    ? toggledComponent({ dismiss })
                    : toggledComponent }), void 0)),
            jsx_runtime_1.jsxs(Button_1.Button, Object.assign({ variant: "floating-action", ref: buttonRef, onClick: e => {
                    if (onClick) {
                        onClick(e);
                    }
                    setVisible(!visible);
                    onToggle(!visible);
                }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), title: props.title ? props.title : typeof label === 'string' ? label : undefined, position: "relative", backgroundColor: "cardBackground", color: "cardText" }, buttonProps, { children: [!!badge && (jsx_runtime_1.jsx(Badge_1.Badge, Object.assign({ position: "absolute", top: "-0.3rem", right: "-0.3rem", backgroundColor: "danger", color: "#fff", display: "block" }, { children: badge }), void 0)),
                    !!icon &&
                        (typeof icon === 'string' ? (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "span", fontSize: "0.75rem", fontWeight: "bold", marginBottom: "0.25rem", display: "inline-block" }, { children: icon }), void 0)) : (jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: icon }, void 0))), children, label && !showToggledComponent && (jsx_runtime_1.jsx(Card_1.Card, Object.assign({ noWrap: true, position: "absolute", left: labelPosition === 'left' ? 'auto' : '100%', right: labelPosition === 'left' ? '100%' : undefined, marginLeft: labelPosition === 'left' ? 0 : '0.75rem', marginRight: labelPosition === 'left' ? '0.75rem' : undefined, transform: "translateY(-100%)", mt: 1, maxWidth: "none", py: 1, px: 2, display: hover ? 'block' : 'none', zIndex: 1 }, { children: label }), void 0))] }), void 0)] }), void 0));
};
exports.FloatingActionButton = FloatingActionButton;
//# sourceMappingURL=index.js.map